const doc = [({"se":({"js":({"routes":({"admin":({"notification_type_actions":({"edit":({})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;